/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts (Dial Rule Restrictions)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Form validation utilities for Dial Rule Restrictions.
────────────────────────────────────────────────────────────────*/

import { FormState, ValidationErrors } from '../types';

/**
 * Validate Dial Rule Restriction form
 */
export function validateDialRuleRestrictionForm(
  formData: FormState,
  t: (key: string) => string
): ValidationErrors {
  const errors: ValidationErrors = {};
  const trimmedName = formData.name.trim();

  if (trimmedName.length === 0) {
    errors.name = t('dialRuleRestrictions.validation.nameRequired');
  } else if (trimmedName.length < 3) {
    errors.name = t('dialRuleRestrictions.validation.nameMinLength');
  }

  // Validate rules
  const emptyPatternIndex = formData.rules.findIndex((rule) => rule.pattern.trim().length === 0);
  if (emptyPatternIndex !== -1) {
    errors.rules = t('dialRuleRestrictions.validation.patternRequired');
  }

  const invalidDurationIndex = formData.rules.findIndex(
    (rule) => rule.playMaxDuration && (!rule.maxDurationSeconds || rule.maxDurationSeconds <= 0)
  );
  if (invalidDurationIndex !== -1) {
    errors.rules = t('dialRuleRestrictions.validation.patternInvalid');
  }

  return errors;
}

